"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToApplicationError = exports.BadRequestError = exports.BAD_REQUEST_ERROR_CODES = exports.InternalServerError = exports.ApplicationError = void 0;
class ApplicationError extends Error {
    constructor(description, originalError) {
        super(description);
        this.description = description;
        this.originalError = originalError;
        Object.setPrototypeOf(this, ApplicationError.prototype);
    }
}
exports.ApplicationError = ApplicationError;
class InternalServerError extends ApplicationError {
    constructor(description, originalError) {
        super(description, originalError);
        this.description = description;
        this.originalError = originalError;
        Object.setPrototypeOf(this, InternalServerError.prototype);
    }
}
exports.InternalServerError = InternalServerError;
exports.BAD_REQUEST_ERROR_CODES = {
    BAD_USER_INPUT: 'BAD_USER_INPUT',
    BAD_PICKING_INPUT: 'BAD_PICKING_INPUT',
    BAD_CUSTOMER_PICKING_INPUT: 'BAD_CUSTOMER_PICKING_INPUT',
    BAD_BOX_INPUT: 'BAD_BOX_INPUT',
    BAD_ID_UPSERT: 'BAD_ID_UPSERT',
    BAD_DEFAULT_CONFIG: 'BAD_DEFAULT_CONFIG',
    NOT_FOUND: 'NOT_FOUND',
    BAD_MARKET_PREFIX_FOR_MSG: 'BAD_MARKET_PREFIX_FOR_MSG',
    BAD_ASSEMBLY_STATION_INPUT: 'BAD_ASSEMBLY_STATION_INPUT',
    BAD_STOCK_INPUT: 'BAD_STOCK_INPUT'
};
class BadRequestError extends ApplicationError {
    constructor(code, description) {
        super(description);
        this.code = code;
        this.description = description;
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
exports.BadRequestError = BadRequestError;
const castToApplicationError = (error) => {
    if (error instanceof ApplicationError) {
        return error;
    }
    return new ApplicationError('Unknown error', error);
};
exports.castToApplicationError = castToApplicationError;
//# sourceMappingURL=index.js.map